import { emailVerifyPlugin } from './email/email'
import { errorPlugin } from './error/error'
import { onboardingPlugin } from './onboarding/onboarding'

import type { PermissionPluginFn } from '@circlefin/permissions'
import type { Session } from 'next-auth'

/**
 * Compose all the permissions plugins..
 */
export const permissionPlugins = (
  session: Session | null,
): PermissionPluginFn[] => [
  // Handle errors
  errorPlugin(session?.status),

  // Handle email verification
  emailVerifyPlugin(session?.status),

  // Handle onboarding
  onboardingPlugin(session?.status),
]
